import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import { mediaQueryUp } from 'components/utils/breakpoint'
import getStaticPagesByType from 'lib/utils/getStaticPagesByType'
import { rem } from 'polished'
import { memo, useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import Accreditations from '../Accreditations'
import CookieSettingsLink from 'components/Consent/CookieSettingsLink'
import FooterItemList from '../FooterItemList'
import FooterListItemsGrid from '../FooterListItemsGrid'
import FooterList from '../FooterList'
import GeoContext from 'contexts/geoContext'
import { agentHubOrSubBrandConfig } from 'agentHub/constants'

const Container = styled(Pane)`
  border-top: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  padding: ${rem(40)} 0;
`

const OfficeLocation = styled(BodyText)`
  padding-inline: ${rem(8)};
`

const CopyrightText = styled.div`
  text-align: center;

  ${mediaQueryUp.tablet} {
    text-align: end;
  }
`

const Divider = styled.hr`
  width: 100%;
  height: 1px;
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  border: none;
`

const LogosAndCopyrights = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(32)};
  align-items: center;

  ${mediaQueryUp.tablet} {
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: space-between;
  }
`

const agentHubHelpItemTypes = [
  'termsAndConditions',
  'privacyPolicy',
]

const currentYear = new Date().getFullYear()
const agentHubHelpItems = getStaticPagesByType(agentHubHelpItemTypes)

function AgentHubGuestFooter() {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)

  return (
    <Container background="light-background" className="hidden-print">
      <LayoutContainer>
        <VerticalSpacer gap={56}>
          <FooterListItemsGrid>
            <FooterItemList
              title={intl.formatMessage({
                id: 'xWpU_rcWFaHJlYEdI6vl',
                defaultMessage: 'Help',
              })}
              items={agentHubHelpItems}
            >
              <CookieSettingsLink variant="list" />
            </FooterItemList>
            <FooterList title={intl.formatMessage({
              id: 'eqoJUM1sSmpH_Voghu5F',
              defaultMessage: 'Head Office',
            })}
            >
              <OfficeLocation variant="medium">
                {intl.formatMessage({
                  id: 'xjXjZEVGb6ULJwL3scs7',
                  defaultMessage: 'Level 4, 68 Clarke Street, Southbank, VIC\u00a03006.',
                })}
                {currentRegionCode === 'AU' && <><br /><br />{intl.formatMessage({
                  id: '-cg81vYYaIfQvaA-tZu-',
                  defaultMessage: 'Australian owned and operated.',
                })}
                </>}
              </OfficeLocation>
            </FooterList>
          </FooterListItemsGrid>
          <Divider />
          <LogosAndCopyrights>
            <Accreditations showProductReviewWinner={false} />
            <CopyrightText>
              <BodyText variant="small">{intl.formatMessage(
                {
                  id: 'AQB8Ioop-hXcKYX-4VO3',
                  defaultMessage: 'Copyright © {year} {brandName}',
                },
                { year: currentYear, brandName: agentHubOrSubBrandConfig.displayFullName },
              )}
              </BodyText>
              <BodyText variant="small">{intl.formatMessage({
                id: 'w-lHqiPrICBzxeV81yJR',
                defaultMessage: 'All rights reserved.',
              })}
              </BodyText>
            </CopyrightText>
          </LogosAndCopyrights>
        </VerticalSpacer>
      </LayoutContainer>
    </Container>
  )
}

export default memo(AgentHubGuestFooter)
